import { render } from "./sectiong.vue?vue&type=template&id=5cae980c"
import script from "./sectiong.vue?vue&type=script&lang=js"
export * from "./sectiong.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__